import "react-tooltip/dist/react-tooltip.css";
import "./company_logo.scss";
import { useState } from "react";

type Props = {
  logoUrl?: string;
  companyName: string;
  size?: "xxsmall" | "xsmall" | "smaller" | "small" | "medium" | "large" | undefined;
};

const CompanyLogo = (props: Props) => {
  const [imageError, setImageError] = useState(false);
  const showPlaceholder = !props.logoUrl || imageError;

  return (
    <div className={`company-logo ${props.size || "medium"}`}>
      {showPlaceholder ? (
        <div className="company-logo__placeholder">
          <div>{props.companyName.charAt(0).toUpperCase()}</div>
        </div>
      ) : (
        <img
          className="company-logo__logo"
          src={props.logoUrl}
          alt={props.companyName}
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );
};

export default CompanyLogo;
